import { supabase } from '../lib/supabase';

// Get payment info for a client
export const getClientPaymentInfo = async (clientId) => {
  try {
    const { data, error } = await supabase
      .from('payment_info')
      .select('*')
      .eq('client_id', clientId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching payment info:', error);
    throw error;
  }
};

// Helper function to unset other primary payment methods
const unsetOtherPrimaryMethods = async (clientId, excludePaymentId = null) => {
  try {
    let query = supabase
      .from('payment_info')
      .update({ is_primary: false })
      .eq('client_id', clientId)
      .eq('is_primary', true);
    
    // Exclude the current payment method if updating
    if (excludePaymentId) {
      query = query.neq('id', excludePaymentId);
    }
    
    const { error } = await query;
    if (error) throw error;
  } catch (error) {
    console.error('Error unsetting other primary methods:', error);
    throw error;
  }
};

// Create payment info
export const savePaymentInfo = async (paymentData) => {
  try {
    // If is_primary is true, unset all other primary methods for this client
    if (paymentData.is_primary) {
      await unsetOtherPrimaryMethods(paymentData.client_id);
    }

    // Insert the new payment info
    const { data, error } = await supabase
      .from('payment_info')
      .insert([paymentData])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving payment info:', error);
    throw error;
  }
};

// Update payment info
export const updatePaymentInfo = async (paymentId, paymentData) => {
  try {
    // Get current payment to check client_id
    const { data: currentPayment, error: fetchError } = await supabase
      .from('payment_info')
      .select('client_id')
      .eq('id', paymentId)
      .single();

    if (fetchError) throw fetchError;

    // If setting as primary, unset all other primary methods for this client
    if (paymentData.is_primary) {
      await unsetOtherPrimaryMethods(currentPayment.client_id, paymentId);
    }

    // Update the payment info
    const { data, error } = await supabase
      .from('payment_info')
      .update(paymentData)
      .eq('id', paymentId)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error updating payment info:', error);
    throw error;
  }
};

// Delete payment info
export const deletePaymentInfo = async (paymentInfoId) => {
  try {
    const { error } = await supabase
      .from('payment_info')
      .delete()
      .eq('id', paymentInfoId);

    if (error) throw error;
  } catch (error) {
    console.error('Error deleting payment info:', error);
    throw error;
  }
};
